<template>
  <div>
    <h5 class="text-primary mt-4">INCLUSIÓN / EXCLUSIÓN DE COBERTURA</h5>
    <b-tabs>
      <b-tab title="Inclusión">
        <b-textarea
          v-model="sol.inclusion"
          rows="5"
          placeholder="Detalle la / las coberturas que desea incluír"
        />
      </b-tab>
      <b-tab title="Exclusión">
        <b-textarea
          v-model="sol.exclusion"
          rows="5"
          placeholder="Detalle la / las coberturas que desea excluir"
        ></b-textarea>
      </b-tab>
    </b-tabs>
    <div class="submit-footer">
      <b-row>
        <b-col></b-col>
        <b-col class="text-right">
          <b-btn
            variant="success"
            @click="submit"
            v-b-tooltip.hover
            title="La presente solicitud está sujeta a aprobación. Los cambios no se guardarán de manera instantánea."
          >

            <i class="fa fa-send-o" v-if="!sending"></i>
            <i class="fa fa-spinner fa-spin" v-else></i>

            Enviar Solicitud
          </b-btn>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  props: ['tomador', 'nroPoliza'],
  data() {
    return {
      sending: false,
      sol: {
        inclusion: '',
        exclusion: ''
      }
    };
  },
  methods: {
    submit: async function() {
      if (!Object.values(this.sol).some(item => item)) {
        this.$toast.error('Debe completar al menos una Inclusión / Exclusión');
        return null;
      }

      this.sending = true;

      await this.$api.post(`endoso/solicitud/cambio-cobertura/${this.tomador}`, {
        pas: {
          codigo: this.$store.state.auth.cod_agente,
          nombre: (this.$store.state.auth.nombre + ' ' + this.$store.state.auth.apellido).replace('null',''),
          email: this.$store.state.auth.email
        },
        solicitud: this.sol,
        poliza: this.nroPoliza
      }).then(() => {
        this.$toast.success('Solicitud de endoso enviada exitosamente.');
      }).catch(err => {
        //console.log(err.response);
        this.$toast.error('Ocurrió un error al enviar la solicitud de endoso.');
      })

      this.sending = false;
    }
  }
};
</script>
